<template>
  <b-modal
    class="mc-modal"
    id="mc-modal-business-data"
    ref="mc-modal-business-data"
    :title="$t('setting.integration.selectBusinessData')"
    size="md"
    centered
    @shown="handleModalOpen"
    @hidden="handleModalClose"
  >
    <div div class="card-body p-2">
      <b-container fluid>
        <b-row>
          <b-col cols="12" class="border p-3 mc-business-list">
            <div class="w-100 mc-business-select">
              <b-tabs pills vertical content-class="w-100" v-model="selectedIndex">
                <b-tab v-for="(business, index) in businessData" :key="business.id">
                  <template #title>
                    <div class="d-flex justify-content-between">
                      <span>{{ business.name }}</span>
                      <span v-if="selectedIndex == index" class="check-icon">
                        <i class="mc-icon fas fa-check-circle"></i>
                      </span>
                    </div>
                  </template>
                </b-tab>
              </b-tabs>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <template #modal-footer="{ cancel }">
      <div class="d-flex">
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('global.action.cancel')"
          @click="cancel"
          :disabled="loading"
        />
        <McButton
          variant="primary"
          :text="$t('global.action.apply')"
          @click="applyBusinessData(cancel)"
          :disabled="loading"
        />
      </div>
    </template>
  </b-modal>
</template>
<script>
import McButton from '@/components/McButton'
import { errorMessage } from '@/helpers/errorHandler'
import errorMessageList from '../../constants/error-message-mapping'
import * as Integration from '@/services/rest-api/lib/setting/integration'
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'

export default {
  components: {
    McButton,
  },
  data() {
    return {
      // Loading true to prevent button blinking as soon as the modal opened
      loading: true,
      selectedIndex: 0,
      businessData: [],
    }
  },
  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
  },
  methods: {
    async getBusinessData() {
      try {
        this.loading = true
        const { business_data, errors } = await Integration.accurateBusinessData()
        if (errors) return
        this.businessData = business_data
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async handleModalOpen() {
      this.getBusinessData()
    },
    handleModalClose() {
      this.businessData = []
      this.selectedIndex = 0
      this.loading = true
    },
    async applyBusinessData(closeCallback) {
      try {
        this.loading = true
        const payload = {
          business_data_id: this.businessData[this.selectedIndex].id,
        }
        const { errors, errors_v2 } = await Integration.accurateBusinessDataConnect(payload)
        if (errors) {
          for (let [key, value] of Object.entries(errors)) {
            if (errorMessageList[key][value[0]]) {
              this.$mcToast.error(errorMessage(errorMessageList[key][value[0]]))
            }
          }
        }

        if (errors_v2) {
          const { errorsMessageHtml, extractedUrl } = Helper.methods.formatAccurateErrorMessages(
            errors_v2.issues
          )

          await this.$mcMessageDialog
            .error({
              title: 'Gagal Menghubungkan ke Accurate',
              subtitle: 'Pesan dari Accurate:',
              content: errorsMessageHtml,
              useHtml: true,
              secondaryButton: { text: 'Salin Link Instalasi', visible: !!extractedUrl },
            })
            .then(async (action) => {
              if (action === 'secondary' && extractedUrl) {
                try {
                  await navigator.clipboard.writeText(extractedUrl)
                  this.$mcToast.success('Link instalasi berhasil disalin')
                } catch (copyErr) {
                  console.error('Failed to copy:', copyErr)
                  this.$mcToast.error('Gagal menyalin link instalasi')
                }
              }
            })
        } else {
          this.$mcToast.success('Integrasi dengan ACCURATE telah berhasil')
        }

        this.$emit('get-list')

        closeCallback()
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
@import './style.scss';
</style>
